module.exports = [
    { value: '0',     label: 'n.a.' },
    { value: '1',     label: 'nicht berechtigt' },
    { value: '2',     label: 'berechtigt' },
    { value: '3',     label: 'berechtigt (in progress)' },
    { value: '10',     label: 'berechtigt (Testaccount)' },
];
